import axios from "../services/api/api";

export const FETCH_STUDENT_RESULTS_LAST_MONTH_BEGIN =
  "FETCH_STUDENT_RESULTS_LAST_MONTH_BEGIN";
export const FETCH_STUDENT_RESULTS_LAST_MONTH_FULFILLED =
  "FETCH_STUDENT_RESULTS_LAST_MONTH_FULFILLED";
export const FETCH_STUDENT_RESULTS_LAST_MONTH_REJECTED =
  "FETCH_STUDENT_RESULTS_LAST_MONTH_REJECTED";

export const FETCH_STUDENT_RESULTS_BY_STUDENT_BEGIN =
  "FETCH_STUDENT_RESULTS_BY_STUDENT_BEGIN";
export const FETCH_STUDENT_RESULTS_BY_STUDENT_FULFILLED =
  "FETCH_STUDENT_RESULTS_BY_STUDENT_FULFILLED";
export const FETCH_STUDENT_RESULTS_BY_STUDENT_REJECTED =
  "FETCH_STUDENT_RESULTS_BY_STUDENT_REJECTED";

export const FETCH_STUDENT_AVERAGE_RESULTS_BY_STUDENT_BEGIN =
  "FETCH_STUDENT_AVERAGE_RESULTS_BY_STUDENT_BEGIN";
export const FETCH_STUDENT_AVERAGE_RESULTS_BY_STUDENT_FULFILLED =
  "FETCH_STUDENT_AVERAGE_RESULTS_BY_STUDENT_FULFILLED";
export const FETCH_STUDENT_AVERAGE_RESULTS_BY_STUDENT_REJECTED =
  "FETCH_STUDENT_AVERAGE_RESULTS_BY_STUDENT_REJECTED";

export const FETCH_STUDENT_RESULTS_TIMELINE_BY_STUDENT_BEGIN =
  "FETCH_STUDENT_RESULTS_TIMELINE_BY_STUDENT_BEGIN";
export const FETCH_STUDENT_RESULTS_TIMELINE_BY_STUDENT_FULFILLED =
  "FETCH_STUDENT_RESULTS_TIMELINE_BY_STUDENT_FULFILLED";
export const FETCH_STUDENT_RESULTS_TIMELINE_BY_STUDENT_REJECTED =
  "FETCH_STUDENT_RESULTS_TIMELINE_BY_STUDENT_REJECTED";

export function fetchStudentResultsAction() {
  return function(dispatch) {
    dispatch({
      type: "FETCH_STUDENT_RESULTS_BEGIN",
      payload: { loading: true }
    });
    axios
      .get("/student/MyResults")
      .then(response => {
        dispatch({
          type: "FETCH_STUDENT_RESULTS_SUCCESS",
          payload: response.data.result
        });
      })
      .catch(err => {
        dispatch({ type: "FETCH_STUDENT_RESULTS_REJECTED", payload: err });
      });
  };
}

export function GetLastMonthsRunsByClassId(classId) {
  return function(dispatch) {
    dispatch({
      type: "FETCH_STUDENT_RESULTS_LAST_MONTH_BEGIN",
      payload: { loading: true }
    });
    axios
      .get("/studentresult/GetLastMonthsRunsByClassId/" + classId)
      .then(response => {
        dispatch({
          type: "FETCH_STUDENT_RESULTS_LAST_MONTH_FULFILLED",
          payload: response.data.result
        });
      })
      .catch(err => {
        dispatch({
          type: "FETCH_STUDENT_RESULTS_LAST_MONTH_REJECTED",
          payload: err
        });
      });
  };
}

export function GetAverageStudentResultByStudent(studentId) {
  return function(dispatch) {
    dispatch({
      type: FETCH_STUDENT_AVERAGE_RESULTS_BY_STUDENT_BEGIN,
      payload: { loading: true }
    });
    axios
      .get("/StudentResult/GetAverageScoreDataByStudent/" + studentId)
      .then(response => {
        dispatch({
          type: FETCH_STUDENT_AVERAGE_RESULTS_BY_STUDENT_FULFILLED,
          payload: response.data.result
        });
      })
      .catch(err => {
        dispatch({
          type: FETCH_STUDENT_AVERAGE_RESULTS_BY_STUDENT_REJECTED,
          payload: err
        });
      });
  };
}

export function GetStudentResultTimeline(studentId) {
  return function(dispatch) {
    dispatch({
      type: FETCH_STUDENT_RESULTS_TIMELINE_BY_STUDENT_BEGIN,
      payload: { loading: true }
    });
    axios
      .get("/StudentResult/GetStudentResultTimeline/" + studentId)
      .then(response => {
        dispatch({
          type: FETCH_STUDENT_RESULTS_TIMELINE_BY_STUDENT_FULFILLED,
          payload: response.data.result
        });
      })
      .catch(err => {
        dispatch({
          type: FETCH_STUDENT_RESULTS_TIMELINE_BY_STUDENT_REJECTED,
          payload: err
        });
      });
  };
}
